// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-picker-container {
  width: 320px;
  height: 300px;
  background-color: white;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 50% 50px 60px 40px 1fr auto;
  font-family: "acumin-pro-condensed";
  font-weight: normal;
  font-size: 14px;
}
.color-picker-container.with-hints {
  height: 380px;
}
.color-picker-container .color-picker-saturation {
  grid-row: 1;
  grid-column: 1;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 100%;
  position: relative;
  cursor: pointer;
}
.color-picker-container .color-picker-saturation .color-picker-saturation-white {
  grid-row: 1;
  grid-column: 1;
  background: -webkit-linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
  background: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
}
.color-picker-container .color-picker-saturation .color-picker-saturation-black {
  grid-row: 1;
  grid-column: 1;
  background: -webkit-linear-gradient(to top, #000, rgba(0, 0, 0, 0));
  background: linear-gradient(to top, #000, rgba(0, 0, 0, 0));
}
.color-picker-container .color-picker-saturation .color-picker-saturation-cursor {
  pointer-events: none;
  width: 4px;
  height: 4px;
  box-shadow: 0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0, 0, 0, 0.3), 0 0 1px 2px rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  transform: translate(-2px, -2px);
  position: absolute;
}
.color-picker-container .color-picker-hue {
  grid-row: 2;
  grid-column: 1;
  display: grid;
  margin: 10px;
  grid-template-columns: 24% 76%;
  grid-template-rows: 100%;
}
.color-picker-container .color-picker-hue .color-picker-hue-color {
  grid-row: 1;
  grid-column: 1;
  align-self: center;
  justify-self: center;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid black;
}
.color-picker-container .color-picker-hue .color-picker-hue-slider {
  grid-row: 1;
  grid-column: 2;
  align-self: center;
  height: 16px;
  position: relative;
  cursor: pointer;
  background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
  background: -webkit-linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
}
.color-picker-container .color-picker-hue .color-picker-hue-slider .color-picker-hue-cursor {
  pointer-events: none;
  width: 8px;
  height: 18px;
  transform: translate(-4px, -2px);
  background-color: rgb(248, 248, 248);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
  position: absolute;
}
.color-picker-container .color-picker-component {
  display: grid;
  margin: 5px;
  grid-template-columns: 100%;
  grid-template-rows: 50% 50%;
}
.color-picker-container .color-picker-component .color-picker-component-value {
  justify-self: center;
  align-self: center;
  grid-row: 1;
  grid-column: 1;
  margin-bottom: 4px;
}
.color-picker-container .color-picker-component .color-picker-component-value input {
  width: 50px;
}
.color-picker-container .color-picker-component .color-picker-component-label {
  justify-self: center;
  align-self: center;
  grid-row: 2;
  grid-column: 1;
  color: black;
}
.color-picker-container .color-picker-rgb {
  grid-row: 3;
  grid-column: 1;
  display: grid;
  margin: 10px;
  grid-template-columns: 20% 6.66% 20% 6.66% 20% 6.66% 20%;
  grid-template-rows: 100%;
}
.color-picker-container .red {
  grid-row: 1;
  grid-column: 1;
}
.color-picker-container .green {
  grid-row: 1;
  grid-column: 3;
}
.color-picker-container .blue {
  grid-row: 1;
  grid-column: 5;
}
.color-picker-container .alpha {
  grid-row: 1;
  grid-column: 7;
}
.color-picker-container .alpha.grayed {
  opacity: 0.5;
}
.color-picker-container .color-picker-hex {
  grid-row: 4;
  grid-column: 1;
  display: grid;
  grid-template-columns: 20% 80%;
  grid-template-rows: 100%;
}
.color-picker-container .color-picker-hex .color-picker-hex-label {
  justify-self: center;
  align-self: center;
  grid-row: 1;
  grid-column: 1;
  margin-left: 10px;
  color: black;
}
.color-picker-container .color-picker-hex .color-picker-hex-value {
  justify-self: left;
  align-self: center;
  grid-row: 1;
  grid-column: 2;
  margin-left: 10px;
  margin-right: 10px;
}
.color-picker-container .color-picker-hex .color-picker-hex-value input {
  width: 70px;
}
.color-picker-container .color-picker-warning {
  color: black;
  font-size: 11px;
  padding: 4px;
  justify-self: left;
  align-self: center;
  grid-row: 6;
  grid-column: 1;
}`, "",{"version":3,"sources":["webpack://./../../../dev/sharedUiComponents/dist/colorPicker/colorPicker.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,2BAAA;EACA,+CAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;AACJ;AACI;EACI,aAAA;AACR;AAEI;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,2BAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;AAAR;AAEQ;EACI,WAAA;EACA,cAAA;EAEA,2EAAA;EACA,mEAAA;AADZ;AAIQ;EACI,WAAA;EACA,cAAA;EAEA,mEAAA;EACA,2DAAA;AAHZ;AAMQ;EACI,oBAAA;EACA,UAAA;EACA,WAAA;EACA,kGAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;AAJZ;AAQI;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,wBAAA;AANR;AAQQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AANZ;AASQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EAEA,2GAAA;EACA,mHAAA;AARZ;AAUY;EACI,oBAAA;EACA,UAAA;EACA,YAAA;EACA,gCAAA;EACA,oCAAA;EACA,2CAAA;EACA,kBAAA;AARhB;AAaI;EACI,aAAA;EACA,WAAA;EACA,2BAAA;EACA,2BAAA;AAXR;AAaQ;EACI,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AAXZ;AAaY;EACI,WAAA;AAXhB;AAeQ;EACI,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AAbZ;AAiBI;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,wDAAA;EACA,wBAAA;AAfR;AAkBI;EACI,WAAA;EACA,cAAA;AAhBR;AAmBI;EACI,WAAA;EACA,cAAA;AAjBR;AAoBI;EACI,WAAA;EACA,cAAA;AAlBR;AAqBI;EACI,WAAA;EACA,cAAA;AAnBR;AAqBQ;EACI,YAAA;AAnBZ;AAuBI;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,wBAAA;AArBR;AAuBQ;EACI,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AArBZ;AAwBQ;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAtBZ;AAwBY;EACI,WAAA;AAtBhB;AA2BI;EACI,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AAzBR","sourcesContent":[".color-picker-container {\r\n    width: 320px;\r\n    height: 300px;\r\n    background-color: white;\r\n    display: grid;\r\n    grid-template-columns: 100%;\r\n    grid-template-rows: 50% 50px 60px 40px 1fr auto;\r\n    font-family: \"acumin-pro-condensed\";\r\n    font-weight: normal;\r\n    font-size: 14px;\r\n\r\n    &.with-hints {\r\n        height: 380px;\r\n    }\r\n\r\n    .color-picker-saturation {\r\n        grid-row: 1;\r\n        grid-column: 1;\r\n        display: grid;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: 100%;\r\n        position: relative;\r\n        cursor: pointer;\r\n\r\n        .color-picker-saturation-white {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n\r\n            background: -webkit-linear-gradient(to right, #fff, rgba(255, 255, 255, 0));\r\n            background: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));\r\n        }\r\n\r\n        .color-picker-saturation-black {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n\r\n            background: -webkit-linear-gradient(to top, #000, rgba(0, 0, 0, 0));\r\n            background: linear-gradient(to top, #000, rgba(0, 0, 0, 0));\r\n        }\r\n\r\n        .color-picker-saturation-cursor {\r\n            pointer-events: none;\r\n            width: 4px;\r\n            height: 4px;\r\n            box-shadow: 0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0, 0, 0, 0.3), 0 0 1px 2px rgba(0, 0, 0, 0.4);\r\n            border-radius: 50%;\r\n            transform: translate(-2px, -2px);\r\n            position: absolute;\r\n        }\r\n    }\r\n\r\n    .color-picker-hue {\r\n        grid-row: 2;\r\n        grid-column: 1;\r\n        display: grid;\r\n        margin: 10px;\r\n        grid-template-columns: 24% 76%;\r\n        grid-template-rows: 100%;\r\n\r\n        .color-picker-hue-color {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n            align-self: center;\r\n            justify-self: center;\r\n            width: 30px;\r\n            height: 30px;\r\n            border-radius: 15px;\r\n            border: 1px solid black;\r\n        }\r\n\r\n        .color-picker-hue-slider {\r\n            grid-row: 1;\r\n            grid-column: 2;\r\n            align-self: center;\r\n            height: 16px;\r\n            position: relative;\r\n            cursor: pointer;\r\n\r\n            background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\r\n            background: -webkit-linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\r\n\r\n            .color-picker-hue-cursor {\r\n                pointer-events: none;\r\n                width: 8px;\r\n                height: 18px;\r\n                transform: translate(-4px, -2px);\r\n                background-color: rgb(248, 248, 248);\r\n                box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\r\n                position: absolute;\r\n            }\r\n        }\r\n    }\r\n\r\n    .color-picker-component {\r\n        display: grid;\r\n        margin: 5px;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: 50% 50%;\r\n\r\n        .color-picker-component-value {\r\n            justify-self: center;\r\n            align-self: center;\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n            margin-bottom: 4px;\r\n\r\n            input {\r\n                width: 50px;\r\n            }\r\n        }\r\n\r\n        .color-picker-component-label {\r\n            justify-self: center;\r\n            align-self: center;\r\n            grid-row: 2;\r\n            grid-column: 1;\r\n            color: black;\r\n        }\r\n    }\r\n\r\n    .color-picker-rgb {\r\n        grid-row: 3;\r\n        grid-column: 1;\r\n        display: grid;\r\n        margin: 10px;\r\n        grid-template-columns: 20% 6.66% 20% 6.66% 20% 6.66% 20%;\r\n        grid-template-rows: 100%;\r\n    }\r\n\r\n    .red {\r\n        grid-row: 1;\r\n        grid-column: 1;\r\n    }\r\n\r\n    .green {\r\n        grid-row: 1;\r\n        grid-column: 3;\r\n    }\r\n\r\n    .blue {\r\n        grid-row: 1;\r\n        grid-column: 5;\r\n    }\r\n\r\n    .alpha {\r\n        grid-row: 1;\r\n        grid-column: 7;\r\n\r\n        &.grayed {\r\n            opacity: 0.5;\r\n        }\r\n    }\r\n\r\n    .color-picker-hex {\r\n        grid-row: 4;\r\n        grid-column: 1;\r\n        display: grid;\r\n        grid-template-columns: 20% 80%;\r\n        grid-template-rows: 100%;\r\n\r\n        .color-picker-hex-label {\r\n            justify-self: center;\r\n            align-self: center;\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n            margin-left: 10px;\r\n            color: black;\r\n        }\r\n\r\n        .color-picker-hex-value {\r\n            justify-self: left;\r\n            align-self: center;\r\n            grid-row: 1;\r\n            grid-column: 2;\r\n            margin-left: 10px;\r\n            margin-right: 10px;\r\n\r\n            input {\r\n                width: 70px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .color-picker-warning {\r\n        color: black;\r\n        font-size: 11px;\r\n        padding: 4px;\r\n        justify-self: left;\r\n        align-self: center;\r\n        grid-row: 6;\r\n        grid-column: 1;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
